export default "__VITE_ASSET__EFnE6IHb__"